class MMFaqDropdown extends HTMLElement {
	constructor() {
		super();
		this._handleDropdown = this.handleDropdown.bind(this);
		this._handleKeydown = this.handleKeydown.bind(this);
	}

	connectedCallback() {
		this.header = this.querySelector('[data-header]');
		this.content = this.querySelector('[data-content]');
		this.icon = this.querySelector('.mm-icon-chevron-down');

// Initial state
		this.content.style.maxHeight = null;
		this.header.setAttribute('aria-expanded', 'false');

		this.header.addEventListener('click', this._handleDropdown);
		this.header.addEventListener('keydown', this._handleKeydown);
	}

	disconnectedCallback() {
		if (this.header) {
			this.header.removeEventListener('click', this._handleDropdown);
			this.header.removeEventListener('keydown', this._handleKeydown);
		}
	}

	handleKeydown(e) {
		if (e.key === ' ' || e.key === 'Enter') {
			e.preventDefault();
			this.handleDropdown();
		}
	}

	handleDropdown() {
		this.toggleAttribute('open');

// Ferme les autres dropdowns dans le même parent
		const siblings = Array.from(this.parentNode.children);
		siblings.forEach((el) => {
			if (el !== this && typeof el.closeDropdown === 'function') {
				el.closeDropdown();
			}
		});

// Toggle ce dropdown
		if (this.header.classList.contains('active')) {
			this.closeDropdown();
		} else {
			this.openDropdown();
		}
	}

	openDropdown() {
		this.header.classList.add('active');
		this.content.style.maxHeight = this.content.scrollHeight + 'px';
		this.icon.style.transform = 'rotate(180deg)';
		this.header.setAttribute('aria-expanded', 'true');
	}

	closeDropdown() {
		this.header.classList.remove('active');
		this.content.style.maxHeight = null;
		this.icon.style.transform = 'rotate(0deg)';
		this.header.setAttribute('aria-expanded', 'false');
		this.removeAttribute('open');
	}
}

customElements.define('mm-faq-dropdown', MMFaqDropdown);
